import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Grid, Button, Dialog, DataTable, SMPopover, DialogPaymentMethods, DialogSeries, makeStyles } from "../../.."; // import selects from '../../../../assets/selects'
// import { Link } from 'react-router-dom';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    divider: {
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "flex-end"
    },
    tabContainer: {
      display: "flex"
    },
    skeleton: {
      padding: "30px",
      width: "60%"
    }
  };
});

var BillingSettingsModule = function BillingSettingsModule(props) {
  var classes = useStyles(); // console.log("BillingSettingsModule", props);

  var data = props.data,
      type = props.type,
      translation = props.translation,
      createItem = props.createItem,
      editItem = props.editItem,
      deleteItem = props.deleteItem,
      columns = props.columns,
      titles = props.titles,
      options = props.options;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];
  /* ----Add */


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openAdd = _useState4[0],
      setOpenAdd = _useState4[1];

  var handleCreate = function handleCreate(values) {
    return createItem(values);
  };

  var handleDialogAdd = function handleDialogAdd() {
    return setOpenAdd(!openAdd);
  };
  /* ----Edit */


  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openEdit = _useState6[0],
      setOpenEdit = _useState6[1]; // useEffect(() => console.log('openEdit useEffect', openEdit), [openEdit])


  var handleEdit = function handleEdit(values) {
    return editItem(values);
  };

  var handleDialogEdit = function handleDialogEdit(id) {
    setSelected(data.find(function (elm) {
      return elm._id === id;
    }));
    setOpenEdit(true);
  };
  /* ----View */


  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openView = _useState8[0],
      setOpenView = _useState8[1];

  var handleDialogView = function handleDialogView(id) {
    // console.log('elm en handleDialogView', data.find(elm => elm._id === id))
    !openView ? setSelected(data.find(function (elm) {
      return elm._id === id;
    })) : setSelected({});
    setOpenView(!openView);
  };
  /* ----Delete */


  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openDelete = _useState10[0],
      setOpenDelete = _useState10[1];

  var handleDialogDelete = function handleDialogDelete(id) {
    !openDelete ? setSelected(data.find(function (elm) {
      return elm._id === id;
    })) : setSelected({});
    setOpenDelete(!openDelete);
  };

  var handleItemPopover = function handleItemPopover(item, id) {
    if (item === "view") {
      handleDialogView(id);
    } else if (item === "edit") {
      handleDialogEdit(id);
    } else if (item === "delete") {
      handleDialogDelete(id);
    }
  }; // eslint-disable-next-line no-unused-expressions


  columns ? columns.find(function (column) {
    return column.name === "options";
  }) ? columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "tasks",
        labels: [{
          label: "View",
          name: "view",
          onItemClick: handleItemPopover
        }, {
          label: "Edit",
          name: "edit",
          onItemClick: handleItemPopover
        }, {
          label: "Delete",
          name: "delete",
          onItemClick: handleItemPopover
        }]
      });
    }
  } : null : null; // eslint-disable-next-line no-unused-expressions

  translation ? translation.datatable ? translation.datatable.columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "tasks",
        labels: [{
          label: "View",
          name: "view",
          onItemClick: handleItemPopover
        }, {
          label: "Edit",
          name: "edit",
          onItemClick: handleItemPopover
        }, {
          label: "Delete",
          name: "delete",
          onItemClick: handleItemPopover
        }]
      });
    }
  } : null : null; // console.log("translation.columns", translation && translation.datatable);

  var contentHandler = function contentHandler(type) {
    switch (type) {
      case "payment_methods":
        return [
        /*#__PURE__*/

        /* Payment Methods Dialogs */

        /* ----Add */
        React.createElement(DialogPaymentMethods, {
          key: "add-payment-method",
          "data-cy": "add-payment-method",
          open: openAdd,
          onClose: handleDialogAdd,
          variant: "add",
          createMethod: handleCreate,
          translation: translation ? translation.dialogs.add : null
        }),
        /*#__PURE__*/

        /* ----Edit */
        React.createElement(DialogPaymentMethods, {
          key: "edit-payment-method",
          "data-cy": "edit-payment-method",
          open: openEdit,
          onClose: function onClose() {
            setSelected({});
            setOpenEdit(false);
          },
          variant: "edit",
          method: selected,
          editMethod: handleEdit,
          translation: translation ? translation.dialogs.add : null
        }),
        /*#__PURE__*/

        /* ----View */
        React.createElement(DialogPaymentMethods, {
          key: "view-payment-method",
          "data-cy": "view-payment-method",
          open: openView,
          onClose: handleDialogView,
          variant: "view",
          method: selected,
          translation: translation ? translation.dialogs.add : null
        })];

      case "series":
        return [
        /*#__PURE__*/

        /* ----Add */
        React.createElement(DialogSeries, {
          key: "add-serie",
          "data-cy": "add-serie",
          open: openAdd,
          onClose: handleDialogAdd,
          variant: "add",
          createSerie: handleCreate,
          translation: translation ? translation.dialogs.add : null
        }),
        /*#__PURE__*/

        /* ----Edit */
        React.createElement(DialogSeries, {
          key: "edit-serie",
          "data-cy": "edit-serie",
          open: openEdit,
          onClose: function onClose() {
            setSelected({});
            setOpenEdit(false);
          },
          variant: "edit",
          serie: selected,
          editSerie: handleEdit,
          translation: translation ? translation.dialogs.add : null
        }),
        /*#__PURE__*/

        /* ----View */
        React.createElement(DialogSeries, {
          key: "view-serie",
          "data-cy": "view-serie",
          open: openView,
          onClose: handleDialogView,
          variant: "view",
          serie: selected,
          translation: translation ? translation.dialogs.add : null
        })];
    }
  };

  return [/*#__PURE__*/React.createElement("div", null, contentHandler(type)),
  /*#__PURE__*/

  /* ----Delete */
  React.createElement(Dialog, {
    open: openDelete,
    onClose: handleDialogDelete,
    id: "modal-confirm-delete",
    "data-cy": "modal-confirm-delete",
    title: translation ? translation.dialogs["delete"].title : "Delete",
    text: translation ? translation.dialogs["delete"].info : "Your item  would be deleted and you can't recover it",
    submit: translation ? translation.dialogs["delete"].buttons["delete"] : "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDelete,
    cancel: translation ? translation.dialogs["delete"].buttons.cancel : "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      deleteItem(selected);
      handleDialogDelete();
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "contained",
    onClick: handleDialogAdd
  }, translation ? translation.buttons.add : type === "payment_methods" ? "+ Add Payment Method" : type === "series" ? "+ Add Serie" : "+ Add")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 9,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: type,
    translation: translation ? translation.datatable : null,
    columns: columns,
    title: titles,
    options: options,
    data: data
  }))];
};

export { BillingSettingsModule };